import { $visualizer } from "@/stores/visualizer";
import { sizeDefault } from "@/utils/constants/sizeDefault";
import type { ImageFile } from "@/utils/types/types";
import { persistentAtom } from "@nanostores/persistent";

export const $selectedImage = persistentAtom<ImageFile | null>(
  "selectedImage",
  null,
  {
    encode: JSON.stringify,
    decode: JSON.parse,
  }
);

$selectedImage.subscribe(image => {
  if (!image) return;

  const store = $visualizer.get();
  if (store.editingItemId) return;

  const size = {
    ...sizeDefault,
    dimensions: {
      height: image.realHeight,
      sqft: (image.realWidth * image.realHeight) / 144,
      width: image.realWidth,
    },
    orientation: image.realWidth >= image.realHeight ? "Landscape" : "Portrait",
  };

  $visualizer.setKey("selectedSize", size);
  $visualizer.setKey("defaultSize", size);
});
